import _, { isEmpty } from "lodash";
import PropTypes from "prop-types";
import { memo, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../../../../app/common-components/ButtonComponent.jsx";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown.jsx";
import DiscardChanges from "../../../../app/common-components/DiscardChanges.jsx";
import CustomSelect from "../../../../app/common-components/Dropdown/CustomSelect.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import { hideOffCanvas } from "../../../../app/commonSlice.js";
import { configurationApi } from "../../../../app/services/configurationApi.js";
import { useCommonAlert } from "../../../../app/utilities/helpers.js";


const UserManagemetDrillDown = ({ ids, recallAPI }) => {
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  const roleOptions = [
    { label: "USER", value: "USER" },
    { label: "OPERATION", value: "OPERATION" },
    { label: "DEVELOPER", value: "DEVELOPER" },
    { label: "TESTER", value: "TESTER" },
    { label: "CISO", value: "CISO" },
    { label: "APPLICATION MANAGER", value: "APPLICATION_MANAGER" },
    { label: "DEPARTMENT HEAD", value: "DEPARTMENT_HEAD" },
    { label: "DIVISION HEAD", value: "DIVISION_HEAD" },
  ];
  const [state, setState] = useState({
    userOptions: [],
    role: [],
    userId: [],
    userinput: "",
    error: false,
    fullName: "",
    email: "",
    errorMessage: "",
    disabled: false,
    addBodyDrilldown: false,
    conformationPopup: false,
    disabledOptions: roleOptions.filter((data) => data.label !== "DEVELOPER" && data.label !== "TESTER" && data.label !== "USER").map(data => data.value),
    roleError: false,
    roleErrorMessage: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { title } = useSelector((state) => state.common.offcanvasState);
  const dispatch = useDispatch();
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [displayName, setdisplayName] = useState("");
  const [mail, setmail] = useState("");
  const [users, setUsers] = useState([]);
  const { userName } = useSelector((state) => state.common.loggedUser);
  const [getUsersDetails] = configurationApi.useLazyGetUsersDetailsQuery();
  const [getUserDetail] = configurationApi.useGetUserDetailMutation();
  const [manageUser] = configurationApi.useManageUserMutation({});


  useEffect(() => {
    getFormData();
  }, []);

  const getFormData = async () => {
    setIsLoading(true);
    try {
      if (title === "Update User") {
        const payload = {
          ids: ids
        };
        const { data } = await getUserDetail({ payload });
        const { userId, email, fullName } = data ? data[0] : data;

        const user = _.flatMap(data.map(d =>
          d.userRole.map(role => _.upperCase(role))
        ));
        const userRoleOptions = user.map(role => ({
          label: role,
          value: capitalizeRole(role)
        }));
        setUsers({ label: userId, value: userId });
        setdisplayName(fullName);
        setmail(email);

        setState((state) => ({
          ...state,
          role: userRoleOptions,
          disabled: true,
        }));
        setIsLoading(false);
        return;
      }

      const { data } = await getUsersDetails();
      const userOptions =
        !isEmpty(data) &&
        data.map((user) => ({
          ...user,
          label: user.uid,
          value: user.uid,
        }));

      setState((state) => ({
        ...state,
        userOptions,
      }));
    } catch (error) {
      callCommonAlert("error", "Failed to fetch data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  function capitalizeRole(role) {
    switch (role) {
      case "Ciso":
        return "CISO";
      case "OPERATION":
        return "OPERATION";
      case "DEVELOPER":
        return "DEVELOPER";
      case "USER":
        return "USER";
      case "APPLICATION MANAGER":
        return "APPLICATION_MANAGER";
      case "DIVISION HEAD":
        return "DIVISION_HEAD";
      case "DEPARTMENT HEAD":
        return "DEPARTMENT_HEAD";
      default:
        return role;
    }
  }

  const getDisabledOptions = (selected) => {
    if (_.isEmpty(selected)) { return []; }

    const selectedValues = selected.map((opt) => opt.value);
    const specialRoles = ["DEVELOPER", "TESTER"];

    // Case 1: Two selected → disable everything else
    if (selectedValues.length >= 2) {
      return roleOptions
        .map((opt) => opt.value)
        .filter((val) => !selectedValues.includes(val));
    }

    // Case 2: One selected
    if (selectedValues.length === 1) {
      const selectedValue = selectedValues[0];

      // If selected is NOT DEVELOPER/TESTER → only allow DEVELOPER or TESTER
      if (!specialRoles.includes(selectedValue)) {
        return roleOptions
          .map((opt) => opt.value)
          .filter(
            (val) =>
              val !== "DEVELOPER" && val !== "TESTER" && val !== selectedValue
          );
      }

      // If selected is DEVELOPER or TESTER → only allow NON-DEVELOPER/TESTER
      return roleOptions
        .map((opt) => opt.value)
        .filter(
          (val) =>
            specialRoles.includes(val) && val !== selectedValue
        );
    }

    // Default: no disabling
    return [];
  };

  const handleOnChange = (name, selected) => {
    const selectedUserObject = state.userOptions.find(
      (user) => user.value === selected.value
    );
    if (name === "userId") {
      setState({
        ...state,
        uid: { label: selected.value, value: selected.value },
        displayName: selectedUserObject.displayName,
        mail: selectedUserObject.mail,
        error: false,
        errorMessage: "",
        conformationPopup: true
      });
      setUsers({ label: selected.value, value: selected.value });
      setmail(selectedUserObject.mail);
      setdisplayName(selectedUserObject.displayName);
    }
    if (name === "role") {
      setState((state) => ({
        ...state,
        role: selected,
        roleError: false,
        roleErrorMessage: "",
      }));
    }
  };
  const userValidation = async () => {
    let isValid = true;
    let errorState = { ...state };

    if (state.userinput.trim() !== "") {
      errorState = {
        ...errorState,
        error: true,
        errorMessage: "Please enter the valid Username",
      };
      isValid = false;
    } else if (isEmpty(users.value)) {
      errorState = {
        ...errorState,
        error: true,
        errorMessage: "Username should not be empty",
      };
      isValid = false;
    } else {
      errorState = {
        ...errorState,
        error: false,
        errorMessage: "",
      };
    }

    if (isEmpty(state.role)) {
      errorState = {
        ...errorState,
        roleError: true,
        roleErrorMessage: "At least one role should be selected",
      };
      // callCommonAlert("error", "At least one role should be selected");
      isValid = false;
    } else {
      errorState = {
        ...errorState,
        roleError: false,
        roleErrorMessage: "",
      };
    }

    setState(errorState);
    return isValid;
  };

  const handleSubmit = async () => {
    const isValid = title !== "Update User" ? await userValidation() : true;
    if (saveDisabled) {
      return;
    }
    // const isValid = title !== "Update User" ? await userValidation() : true;
    if (isValid) {
      setSaveDisabled(true);
      const payload = {
        ids: ids || [0],
        userId: users.value,
        fullName: displayName,
        role: [],
        userRole: _.map(state.role, "value"),
        email: mail,
        status: "DISABLE",
        updatedDate: new Date().toISOString(),
      };
      setIsLoading(true);
      manageUser({ payload, userName })
        .then((data) => {
          setIsLoading(false);
          if (Math.floor(data.data.statusCodeValue / 100) === 2) {
            recallAPI();
            callCommonAlert("success", data.data.body);
            hideCommonAlert();
            setIsLoading(false);
            setTimeout(() => {
              dispatch(hideOffCanvas(false));
            }, 700);
          } else if (data?.data?.statusCodeValue === 400) {
            callCommonAlert("error", data.data.body);
            hideCommonAlert();
            setIsLoading(false);
          } else {
            callCommonAlert("error", "Something went wrong please try again");
            hideCommonAlert();
            setIsLoading(false);
          }
        })
        .finally(() => {
          setSaveDisabled(false);
        });
      // } else {
      //   setSaveDisabled(false);
    }
  };
  const handleButtonClick = () => {
    dispatch(hideOffCanvas());
    addBodyCloseDrilldown();
  };

  const addmodalCancelDrilldown = () => {
    setState((state) => ({
      ...state,
      addBodyDrilldown: true,
    }));
  };
  const addBodyCloseDrilldown = () => {
    setState({
      ...state,
      addBodyDrilldown: false,
      conformationPopup: false
    });
  };
  const addBodyCloseDrilldowns = () => {
    setTimeout(() => {
      dispatch(hideOffCanvas(false));
    }, 100);
  };
  const addBodyCancelDrilldown = () => {
    return (
      <>
        <DiscardChanges title={title === "Update User" ? 'edit' : 'add'} discardClick={handleButtonClick} cancelClick={addBodyCloseDrilldown} />
      </>
    );
  };

  return (
    <div>
      {isLoading ? (
        <Spinners />
      ) : (
        <>
          <form id="userFrom">
            <div className="row m-0">
              <Row>
                <Col>
                  <label className="form-label">Username<span className="RedHighlight">*</span></label>
                  <CustomSelectDropDown
                    id="userId"
                    options={state.userOptions}
                    placeholder={"Enter Username"}
                    name={"Username"}
                    containerClassName={"frmgroup validate default-input custom-select-server"}
                    selected={state.userOptions}
                    value={users}
                    error={state.error}
                    onChange={(selected) => handleOnChange("userId", selected)}
                    errorMessage={state.errorMessage}
                    isDisabled={state.disabled}
                  />
                </Col>
                <Col>
                  <div className="frmgroup default-input">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      id="usegroup"
                      value={displayName}
                      name={"fullName"}
                      placeholder={"Full Name"}
                      data-testid="full-name-input"
                      autoComplete={"off"}
                      disabled={true}
                      label={"Full Name"}
                      className="form-control"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="frmgroup default-input">
                    <label className="form-label">Email ID</label>
                    <input
                      className="form-control"
                      type="text"
                      id="user2"
                      value={mail}
                      name={"email"}
                      placeholder={"Email ID"}
                      data-testid="email-id-input"
                      autoComplete={"off"}
                      disabled={true}
                      label={"Mail"}
                    />
                  </div>
                </Col>
                <Col>
                  <div className="frmhead">
                    <label className="form-label">Role<span className="RedHighlight">*</span></label>
                    {state.roleError && (
                      <div className="error">{state.roleErrorMessage}</div>
                    )}
                  </div>
                  <CustomSelect
                    options={roleOptions}
                    multiSelect={true}
                    hideSelectedOptions={false}
                    isCheckboxSelect={true}
                    placeholder="Role"
                    isSearchable={true}
                    closeMenuOnSelect={false}
                    onChange={(selected) => handleOnChange("role", selected)}
                    showSelectAllButton={true}
                    disabledOptions={getDisabledOptions(state.role)}
                    defaultSelected={state.role}
                    isError={state.roleError}
                  />
                  <CustomModal
                    modalOpen={state.addBodyDrilldown}
                    modalBody={addBodyCancelDrilldown}
                    modalHide={addmodalCancelDrilldown}
                    closeBtn={true}
                    closeBtnFuc={addBodyCloseDrilldown}
                  />
                </Col>
              </Row>
              <Row>
                <Col></Col>
                <Col>
                  <div className="btnwrap">
                    <ButtonComponent
                      text="Cancel"
                      className={"cancelBtnStyle"}
                      data-testid="cancel-user-drilldown-btn"
                      onClick={() => {
                        if (state.conformationPopup) {
                          addmodalCancelDrilldown();
                        } else {
                          addBodyCloseDrilldowns();
                        }
                      }}
                    />
                    <ButtonComponent text="Save" data-testid="save-user-drilldown-btn" onClick={handleSubmit} />
                  </div>
                </Col>
              </Row>
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default memo(UserManagemetDrillDown);

UserManagemetDrillDown.propTypes = {
  ids: PropTypes.number.isRequired,
  recallAPI: PropTypes.func.isRequired
};